import { Box, Tbody, Td, Th, Thead, Tr } from '@bonusly/design-system';

import { BizyTableShell } from './bizy-table-shell';

interface BizyMarkdownTableProps {
	children: React.ReactNode;
}

/**
 * Renders a markdown table (from Streamdown) inside the shared Bizy table
 * chrome (styled table + copy / CSV download + mobile wrapper). The chrome
 * lives in BizyTableShell so the typed Node::Table renderer can reuse it.
 */
export function BizyMarkdownTable({ children }: BizyMarkdownTableProps) {
	return (
		<Box mt={4} mb={2}>
			<BizyTableShell>{children}</BizyTableShell>
		</Box>
	);
}

export const bizyTableComponents = (fontSize: string) => ({
	table: ({ children }: React.TableHTMLAttributes<HTMLTableElement>) => <BizyMarkdownTable>{children}</BizyMarkdownTable>,
	thead: ({ children }: React.HTMLAttributes<HTMLTableSectionElement>) => <Thead>{children}</Thead>,
	tbody: ({ children }: React.HTMLAttributes<HTMLTableSectionElement>) => <Tbody>{children}</Tbody>,
	tr: ({ children }: React.HTMLAttributes<HTMLTableRowElement>) => <Tr>{children}</Tr>,
	th: ({ children, style }: React.ThHTMLAttributes<HTMLTableCellElement>) => (
		<Th fontSize={fontSize} fontWeight="semibold" color="inherit" px={4} py={2.5} style={style}>
			{children}
		</Th>
	),
	td: ({ children, style }: React.TdHTMLAttributes<HTMLTableCellElement>) => (
		<Td fontSize={fontSize} color="inherit" style={style}>
			{children}
		</Td>
	),
});
